// extracted by mini-css-extract-plugin
export var animationContainer = "_r1-0";
export var footer = "_r1-1";
export var gray = "_r1-2";
export var lineItem = "_r1-3";
export var lineItemImage = "_r1-4";
export var lineItemInfo = "_r1-5";
export var lineItemText = "_r1-6";
export var lineItems = "_r1-7";
export var modalContent = "_r1-8";
export var options = "_r1-9";
export var orderName = "_r1-a";
export var refundAmount = "_r1-b";